export default __webpack_public_path__ + "a4fb03620d593254c23f0e3881ab6235.svg";